module.exports = __webpack_public_path__ + "src/img/down.cbec987b.svg";